jQuery(document).ready(function ($) {
    $('.news-carousel-container').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        fade: false,
        autoplay: true,
        responsive: [
            {
                breakpoint: 640,
                settings: {
                    arrows: false,
                }
            },
        ]
    })
})
